<template>
  <base-modal
    ref="modal"
    :title="title"
    @show="toggleModal"
    @hidden="resetModal"
    @ok="handleOk"
    ok-title="Save"
    cancel-title="Cancel"
    cancel-variant="light"
    footer-class="justify-between"
    size="xl"
  >
    <form ref="form" @submit.stop.prevent="handleSubmit">
      <div class="mb-4"><label for="title" class="block text-[13px] font-medium text-ink mb-1.5">Title</label>
        <input
          id="title"
          v-model="libraryComponent.title"
          required
          placeholder=""
          class="w-full border border-border-hover rounded-[10px] px-3.5 py-2.5 text-sm font-[inherit] leading-normal transition-[border-color] duration-150 focus:border-primary focus:ring-3 focus:ring-primary/10 outline-none"
        >
      </div>

      <div class="mb-4"><label for="code" class="block text-[13px] font-medium text-ink mb-1.5">Code</label>
        <textarea
          id="code"
          v-model="libraryComponent.code"
          placeholder=""
          rows="2"
          max-rows="10"
          class="w-full border border-border-hover rounded-[10px] px-3.5 py-2.5 text-sm font-[inherit] leading-normal transition-[border-color] duration-150 focus:border-primary focus:ring-3 focus:ring-primary/10 outline-none">
        </textarea>
      </div>

      <div class="mb-4"><label for="css" class="block text-[13px] font-medium text-ink mb-1.5">CSS</label>
        <textarea
          id="css"
          v-model="libraryComponent.css"
          placeholder=""
          rows="2"
          max-rows="10"
          class="w-full border border-border-hover rounded-[10px] px-3.5 py-2.5 text-sm font-[inherit] leading-normal transition-[border-color] duration-150 focus:border-primary focus:ring-3 focus:ring-primary/10 outline-none">
        </textarea>
      </div>

      <div class="mb-4"><label for="status" class="block text-[13px] font-medium text-ink mb-1.5">Payment</label>
        <base-select v-model="libraryComponent.isPaid" :options="paymentOptions" value-key="value" label-key="text" placeholder="Select payment"></base-select>
      </div>

      <div class="mb-4"><label for="status" class="block text-[13px] font-medium text-ink mb-1.5">Status</label>
        <base-select v-model="libraryComponent.isActive" :options="statusOptions" value-key="value" label-key="text" placeholder="Select status"></base-select>
      </div>

      <div>
        <p>Preview</p>
        <div class="rounded-lg border border-border" ref="card">
          <iframe
            x-ref="iframe"
            id="iframe"
            class="w-full h-full iframe-full-height"
            :srcdoc="`&lt;!doctype html&gt;&lt;meta charset=&quot;utf-8&quot;&gt;&lt;meta name=&quot;viewport&quot; content=&quot;width=device-width, initial-scale=1, shrink-to-fit=no&quot;&gt;&lt;link rel=&quot;stylesheet&quot; href=&quot;https://cdn.jsdelivr.net/npm/bootstrap@5.2.0/dist/css/bootstrap.min.css&quot;&gt;&lt;script src=&quot;https://cdn.jsdelivr.net/npm/bootstrap@5.2.0/dist/js/bootstrap.bundle.min.js&quot;&gt;&lt;/script&gt;&lt;style&gt;${libraryComponent.css}&lt;/style&gt;&lt;body&gt;&lt;div&gt;
  ${libraryComponent.code}
            &lt;/body&gt;`">
          </iframe>
        </div>
      </div>
    </form>
  </base-modal>
</template>

<script>
import { mapState } from 'vuex'
import dayjs from 'dayjs'
import { slugify } from '@/services/utils'
import BaseSelect from '../../UIComponents/BaseSelect'

export default {
  components: { BaseSelect },
  props: ['item', 'librarySlug', 'libraryClass', 'componentIndex'],
  data () {
    return {
      libraryComponent: {
        title: '',
        slug: '',
        createdAt: '',
        isActive: true,
        code: '',
        css: '',
        isPaid: false
      }
    }
  },
  computed: {
    ...mapState({
      statusOptions: state => state.auth.statusOptions,
      paymentOptions: state => state.auth.paymentOptions
    }),
    slug () {
      return slugify(this.libraryComponent.title)
    },
    title () {
      if (this.item) {
        return 'Edit component'
      } else {
        return 'Add component'
      }
    }
  },
  methods: {
    checkFormValidity () {
      const valid = this.$refs.form.checkValidity()
      this.nameState = valid ? 'valid' : 'invalid'
      return valid
    },
    handleSubmit () {
      const { libraryComponent, librarySlug, libraryClass } = this
      if (this.item) {
        this.$store.dispatch('UPDATE_SINGLE_LIBRARY_COMPONENT', { librarySlug, libraryComponent, libraryClass }).then((response) => {
          this.$emit('update')
          this.$nextTick(() => {
            this.$refs.modal.hide()
          })
        })
      } else {
        this.libraryComponent.slug = this.slug
        this.libraryComponent.createdAt = dayjs().format()
        this.$store.dispatch('ADD_SINGLE_LIBRARY_COMPONENT', { librarySlug, libraryComponent, libraryClass }).then((response) => {
          this.$emit('update')
          this.$nextTick(() => {
            this.$refs.modal.hide()
          })
        })
      }
    },
    resetModal () {
      this.libraryComponent.title = ''
      this.libraryComponent.createdAt = ''
      this.libraryComponent.slug = ''
      this.libraryComponent.isActive = true
      this.libraryComponent.code = ''
      this.libraryComponent.css = ''
      this.libraryComponent.library = this.librarySlug
      this.libraryComponent.category = this.libraryClass.slug
      this.libraryComponent.isPaid = false
    },
    showModal () {
      this.$refs['modal'].show()
    },
    hideModal () {
      this.$refs['modal'].hide()
    },
    toggleModal () {
      this.resetModal()
      if (this.item) {
        this.libraryComponent.id = this.item.id
        this.libraryComponent.title = this.item.title
        this.libraryComponent.createdAt = this.item.createdAt
        this.libraryComponent.isActive = this.item.isActive
        this.libraryComponent.slug = this.item.slug
        this.libraryComponent.code = this.item.code
        this.libraryComponent.css = this.item.css
        this.libraryComponent.library = this.item.library ? this.item.library : this.librarySlug
        this.libraryComponent.category = this.item.category ? this.item.category : this.libraryClass.slug
        this.libraryComponent.isPaid = this.item.isPaid ? this.item.isPaid : false

        setTimeout(() => {
          this.$refs.card.style.height = document.getElementById('iframe').contentWindow.document.body.scrollHeight + 100 + 'px'
        }, 500)
      }
    },
    handleOk (bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    }
  },
  mounted () {
  },
  created () {
  }
}
</script>